module.exports = __webpack_public_path__ + "static/media/banner.14b4a4ba.jpeg";